import { z } from "zod";

export const sourceEnum = z.enum(["WEB", "BAPI", "MOBILE"]);
export type Source = z.infer<typeof sourceEnum>;
